import { DATFeedback } from "../screens/datdocuments/feedback/allactions"
import { DATOrder, DATOrderdetail } from "../screens/datdocuments/order/allactions"
import { DATQuotation } from "../screens/datdocuments/quotation/allactions"
import { DATSearchPaket } from "../screens/datdocuments/searchpaket/allactions"
import { DATInvoice } from "../screens/datdocuments/invoice/allactions"

import { PKGPackagingCustomerChooser } from "../screens/pkgpackaging/packagingcustomerchooser/allactions"

import {
  QUTOffering,
  QUTOfferingAdmin,
  QUTOfferingAdminCut,
} from "../screens/qutoffering/offering/allactions"
import { QUTOfferingDetails } from "../screens/qutoffering/offering/details/allactions"

import { SPCSymbolPC } from "../screens/spcsymbolpc/allactions"
import { SPCSymbolPCEndUser } from "../screens/spcsymbolpcenduser/allactions"

export let screens = {
  DATFeedback,
  DATOrder,
  DATOrderdetail,
  DATQuotation,
  DATSearchPaket,
  DATInvoice,

  QUTOffering,
  QUTOfferingAdmin,
  QUTOfferingAdminCut,
  QUTOfferingDetails,

  PKGPackagingCustomerChooser,

  SPCSymbolPC,
  SPCSymbolPCEndUser,
}
